import SC from "./style";
import { useState, useEffect, useRef } from "react";
import { apiPost, apiGet } from "api/callApi";
import { Button, Label, Loader } from "InnoUI/components";
import theme from "theme";
import InnoIcons from "InnoUI/innoicons";
import { useSelector } from "react-redux";
import { getCompany } from "@store/company/actions";
import { useDispatch } from "react-redux";
import {
  convertBase64,
  regexTypes,
  validateEmail,
  validtionMessages,
} from "utils/config";
import {
  CountryCodeDropdown,
  InputField,
  PropertyUnitDropdown,
  TimeZoneWithCountryDropdown,
} from "components";
import ProjectTemplateOptionDropdown from "components/ProjectTemplateOptionDropdown";
import { ConfigProvider, DatePicker, Space, Tabs } from "antd";
import dayjs from "dayjs";
import ct from "countries-and-timezones";
import { Checkbox } from "@mui/material";
import { showAlert } from "utils/helper";
import { useNavigate } from "react-router";

function AddEditProjects(props) {
  const {
    onClose,
    projectdata,
    isEditing,
    rowId,
    setProjects = () => {},
    fetchData = () => {},
    reload = false,
  } = props;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const userType = useSelector((state) => state?.authdata?.data?.userType ?? 2);
  const isAdminOrSuper = userType === 0 || userType === 1;
  const [step, setStep] = useState(1);
  const [activeTab, setActiveTab] = useState("details");
  const [savedProjectId, setSavedProjectId] = useState(
    isEditing ? rowId : null,
  );
  const [wizardTemplates, setWizardTemplates] = useState([]);
  const [selectedWizardIds, setSelectedWizardIds] = useState([]);
  const [wizardLoading, setWizardLoading] = useState(false);
  const [wizardSearchTerm, setWizardSearchTerm] = useState("");
  const [data, setData] = useState({
    logoImage: "",
    displayImage: "",
    cellCode: "+27",
    unit: "m²",
    countryName: null,
    timeZone: null,
    dateCheckbox: 0,
  });
  const [errorKeys, setErrorKeys] = useState({
    email: false,
  });
  const [countryOptions, setCountryOptions] = useState([]);
  const [timezoneOptions, setTimezoneOptions] = useState([]);
  const [isChange, setIsChange] = useState({
    logoImage: false,
    displayImage: false,
  });
  const fileInputRefLogo = useRef(null);
  const fileInputRefDisplay = useRef(null);
  const companyData = useSelector((state) => state.companyData || []);
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [displayTemplateName, setDisplayTemplateName] = useState(
    isEditing ? projectdata?.displayTemplateName || "" : "",
  );

  useEffect(() => {
    dispatch(getCompany());
  }, []);

  console.log(
    projectdata,
    displayTemplateName,
    "projectdata in add edit drawer",
  );

  // Set initial data based on editing state
  useEffect(() => {
    if (isEditing) {
      const newData = { ...projectdata, dateCheckbox: 0 };
      if (projectdata?.userType === 2) {
        newData.adminStatus = false;
      } else {
        newData.adminStatus = true;
      }
      setData(newData);
      console.log(projectdata?.displayTemplateName, "displayTemplateName");
      setDisplayTemplateName(projectdata?.displayTemplateName || "");
      if (newData.countryName) {
        const selectedCountry = countryOptions.find(
          (country) => country.value === newData.countryName,
        );

        const newTimezones = selectedCountry?.timezones || [];
        setTimezoneOptions(
          newTimezones.map((tz) => ({
            label: getTiezonelabel(tz),
            value: tz,
          })),
        );
      }
    }
  }, [isEditing, projectdata, countryOptions]);

  // Load wizard templates for add step-2 or edit Folder Templates tab

  const fetchWizardTemplates = async (projectId) => {
    if (!projectId) return;

    setWizardLoading(true);

    try {
      const response = await apiGet(
        `/v1/projects/templateoptions/${projectId}`,
        false,
      );

      const templates = response.data || [];

      setWizardTemplates(
        templates.map((t) => ({
          id: t.folderTemplateId,
          label: t.folderTemplateName,
        })),
      );

      setSelectedWizardIds(
        templates
          .filter((t) => t.isAssigned === 1)
          .map((t) => t.folderTemplateId),
      );
    } catch (error) {
      console.error("Error fetching wizard templates", error);
    } finally {
      setWizardLoading(false);
    }
  };

  useEffect(() => {
    const shouldLoad = isEditing ? activeTab === "templates" : step === 2;

    if (!shouldLoad || !savedProjectId || !isAdminOrSuper) return;

    fetchWizardTemplates(savedProjectId);
  }, [step, activeTab, savedProjectId, isEditing, isAdminOrSuper]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!data.displayTemplate) {
      setErrorMessage("Folder Template is required");
      return;
    }

    if (!data.openingDate && data.dateCheckbox == 0) {
      showAlert({
        title: "Warning",
        text: "Opening date is required",
        icon: "warning",
      });
      return;
    }

    if (!data.countryName) {
      showAlert({
        title: "Warning",
        text: "Please select  country",
        icon: "warning",
      });
      return;
    }
    if (data.countryName && !data.timeZone) {
      showAlert({
        title: "Warning",
        text: "Please select a timezone after selecting a country.",
        icon: "warning",
      });
      return; // Prevent form submission if timezone is not selected
    }

    // ✅ If contactNo is present, cellCode is required
    const hasContactNo =
      data.contactNo && data.contactNo.toString().trim() !== "";
    const hasCellCode = data.cellCode && data.cellCode.toString().trim() !== "";

    if (hasContactNo && !hasCellCode) {
      showAlert({
        title: "Warning",
        text: "Country code is required when Contact No. is provided.",
        icon: "warning",
      });
      return;
    }

    // 👇 Handle contactNo / cellCode logic before submitting
    const submissionData = {
      ...data,
      cellCode: hasContactNo ? data.cellCode : "",
    };

    setErrorKeys({
      email: false,
    });
    setLoading(true);
    try {
      const endpoint = isEditing
        ? `/v1/editproject/${rowId}`
        : `/v1/addproject`;
      if (isEditing) {
        if (!isChange.logoImage && submissionData.logoImage) {
          delete submissionData.logoImage;
        }
        if (!isChange.displayImage && submissionData.displayImage) {
          delete submissionData.displayImage;
        }
      }
      const response = await apiPost(endpoint, submissionData);
      setLoading(false);
      showAlert({ title: "Success", text: response?.message, icon: "success" });
      if (reload) {
        navigate(0);
      }
      setProjects((prevData) =>
        isEditing
          ? prevData.map((project) =>
              project.id == rowId ? response.data : project,
            )
          : [response.data, ...prevData],
      );
      await fetchData();
      if (isAdminOrSuper) {
        const projectId = isEditing ? rowId : response.data?.id;
        setSavedProjectId(projectId);
        await fetchWizardTemplates(projectId);

        setStep(2);
      } else {
        onClose();
      }
    } catch (error) {
      console.error("Error:", error);
      showAlert({
        title: "error",
        text: error?.response?.data?.message || "An error occurred",
        icon: "error",
      });
      setLoading(false);
    }
  };

  const handleChange = async (property, value, label) => {
    if (property === "displayTemplate") {
      setErrorMessage("");
    }

    console.log(property, value, "property and value");

    if (property === "dateCheckbox" && value == 1) {
      setData((prevData) => ({
        ...prevData,
        [property]: value,
        openingDate: null,
      }));
      return;
    }
    const trimmedValue = typeof value === "string" ? value.trimStart() : value;
    if (isEditing && property === "displayTemplate") {
      const userConfirmed = await showAlert({
        title: "Are you sure?",
        text: "All the previous Template Data will be lost.",
        icon: "warning",
        buttons: ["Cancel", "OK"],
        dangerMode: true,
      });

      if (!userConfirmed) {
        return;
      }
    }
    if (isEditing && (property == "logoImage" || property == "displayImage")) {
      setIsChange(true);
    }

    if (property === "email" || property === "secondaryEmail") {
      if (!validateEmail(trimmedValue)) {
        setErrorKeys((prevKeys) => ({ ...prevKeys, [property]: true }));
      } else {
        setErrorKeys((prevKeys) => ({ ...prevKeys, [property]: false }));
      }
    }

    // 👇 Check contactNo: if empty, reset cellCode
    if (
      property === "contactNo" &&
      (!trimmedValue || trimmedValue.length === 0)
    ) {
      setData((prevData) => ({
        ...prevData,
        contactNo: "",
        cellCode: "", // or "" depending on your requirement
      }));
      return;
    }

    if (property === "displayTemplate") {
      setDisplayTemplateName(label || "");
    }
    setData((prevData) => ({
      ...prevData,
      [property]: trimmedValue,
    }));
  };

  const handleRemoveImage = (type) => {
    setData((prevData) => ({
      ...prevData,
      [type]: "",
    }));
  };

  const handleImageChange = async (e, type) => {
    const file = e.target.files[0];
    try {
      if (isEditing && (type === "logoImage" || type === "displayImage")) {
        setIsChange((prev) => ({ ...prev, [type]: true }));
      }
      const base64Image = await convertBase64(file, 5 * 1024 * 1024);
      setData((prevData) => ({
        ...prevData,
        [type]: base64Image.preview,
      }));
    } catch (error) {
      alert(error);
    } finally {
      e.target.value = "";
    }
  };

  useEffect(() => {
    const allCountries = ct.getAllCountries();
    const countryList = Object.values(allCountries).map((country) => ({
      label: country.name,
      value: country.id,
      timezones: country.timezones,
    }));
    setCountryOptions(countryList);
  }, []);

  const handleCountryChange = (countryId) => {
    const selectedCountry = countryOptions.find(
      (country) => country.value === countryId,
    );
    const newTimezones = selectedCountry?.timezones || [];
    setData((prevData) => ({
      ...prevData,
      countryName: selectedCountry ? selectedCountry.value : null,
      timeZone: null,
    }));
    // Update timezone options
    setTimezoneOptions(
      newTimezones.map((tz) => ({
        label: getTiezonelabel(tz),
        value: tz,
      })),
    );
  };

  const getTiezonelabel = (tz) => {
    const timezone = ct.getTimezone(tz);
    let label = `(GMT ${timezone.utcOffsetStr})` + " " + timezone.name;
    return label;
  };

  const handleTimezoneChange = (timezoneValue) => {
    setData((prevData) => ({
      ...prevData,
      timeZone: timezoneValue,
    }));
  };

  const handleWizardSave = async () => {
    setWizardLoading(true);
    try {
      await apiPost(`/v1/projects/templateoptions/${savedProjectId}`, {
        folderTemplateIds: selectedWizardIds,
      });
      showAlert({
        title: "Success",
        text: "Folder templates assigned successfully",
        icon: "success",
      });
      if (!isEditing) {
        onClose();
      }
    } catch (error) {
      showAlert({
        title: "Error",
        text: error?.response?.data?.message || "An error occurred",
        icon: "error",
      });
    } finally {
      setWizardLoading(false);
    }
  };

  const handleWizardToggle = (templateId) => {
    setSelectedWizardIds((prev) =>
      prev.includes(templateId)
        ? prev.filter((id) => id !== templateId)
        : [...prev, templateId],
    );
  };

  const wizardContent = (
    <SC.FormWrapper style={{ padding: "0px 15px" }}>
      <div style={{ fontSize: "12px", color: "#555", marginBottom: "12px" }}>
        Select folder templates to assign to{" "}
        <strong>{data.propertyName}</strong>
      </div>
      <SC.InputContiner>
        <SC.SearchIcon />
        <SC.InputStyle
          placeholder="Search templates..."
          value={wizardSearchTerm}
          onChange={(e) => setWizardSearchTerm(e.target.value)}
        />
        {wizardSearchTerm && (
          <button
            onClick={() => setWizardSearchTerm("")}
            style={{
              position: "absolute",
              right: "8px",
              background: "none",
              border: "none",
              cursor: "pointer",
              fontSize: "16px",
              color: "#999",
              padding: "4px 8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            title="Clear search"
          >
            ✕
          </button>
        )}
      </SC.InputContiner>
      {wizardTemplates.length === 0 && !wizardLoading && (
        <div
          style={{
            color: "#999",
            fontSize: "12px",
            textAlign: "center",
            padding: "24px 0",
          }}
        >
          No folder templates available
        </div>
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "6px",
          maxHeight: "450px",
          overflowY: "auto",
        }}
      >
        {wizardTemplates
          .filter((t) =>
            t.label.toLowerCase().includes(wizardSearchTerm.toLowerCase()),
          )
          .map((t) => {
            const checked = selectedWizardIds.includes(t.id);
            return (
              <div
                key={t.id}
                onClick={() => handleWizardToggle(t.id)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  cursor: "pointer",
                  padding: "8px 12px",
                  border: `1px solid ${checked ? theme.colors.themeColor : "#e0e0e0"}`,
                  borderRadius: "4px",
                  background: checked ? "#fff5ec" : "#fff",
                  transition: "border-color 0.15s, background 0.15s",
                }}
              >
                <Checkbox
                  checked={checked}
                  onChange={() => handleWizardToggle(t.id)}
                  onClick={(e) => e.stopPropagation()}
                  sx={{
                    "&.Mui-checked": { color: theme.colors.themeColor },
                    padding: "2px",
                  }}
                  size="small"
                />
                <span style={{ fontSize: "13px" }}>{t.label}</span>
              </div>
            );
          })}
      </div>
      <SC.ButtonContainer style={{ marginTop: "16px" }}>
        <Button
          caption="Save"
          onClick={handleWizardSave}
          isLoading={wizardLoading}
          color={theme.colors.white}
          fontSize="12px"
          style={{
            marginBottom: 8,
            background: theme.gradient.themeGradient,
            minWidth: "100px",
            borderRadius: "3px",
            height: "30px",
          }}
        />
      </SC.ButtonContainer>
    </SC.FormWrapper>
  );

  if (step === 2) {
    return (
      <>
        <SC.DrawerTitlesContainer>
          <SC.DrawerTitles>Assign Folder Templates</SC.DrawerTitles>
          <SC.CloseIcon>
            <InnoIcons.CloseIcon onClick={onClose} />
          </SC.CloseIcon>
        </SC.DrawerTitlesContainer>
        {wizardLoading && <Loader />}
        {wizardContent}
      </>
    );
  }

  const formContent = (
    <SC.Form onSubmit={handleSubmit}>
      <SC.FormWrapper>
        <SC.LabelContainer>
          <SC.Label>
            Property Name <SC.Astrik>*</SC.Astrik>
          </SC.Label>
          <SC.Children>
            <SC.Wrapper>
              <InputField
                name="propertyName"
                value={data.propertyName}
                onChange={handleChange}
                required
              />
            </SC.Wrapper>
          </SC.Children>
        </SC.LabelContainer>
        {/* Folder Template */}
        <SC.LabelContainer>
          <SC.Label>
            Folder Template <SC.Astrik>*</SC.Astrik>
          </SC.Label>
          <SC.Children>
            <SC.Wrapper>
              {data.displayTemplate && (
                <SC.DisplayTemplateName
                  title={displayTemplateName || data.displayTemplate}
                >
                  {displayTemplateName || data.displayTemplate}
                </SC.DisplayTemplateName>
              )}
              <ProjectTemplateOptionDropdown
                name="displayTemplate"
                onChange={handleChange}
                defaultValue={data.displayTemplate}
                projectId={isEditing ? rowId : null}
                width={data.displayTemplate ? "200px" : "80%"}
                asChangePicker={!!data.displayTemplate}
              />
            </SC.Wrapper>
            {errorMessage && (
              <span
                style={{ color: theme.colors.themeColor, fontSize: "12px" }}
              >
                {errorMessage}
              </span>
            )}
          </SC.Children>
        </SC.LabelContainer>
        {/* Logo Image Upload */}
        <Label label="Logo Image">
          <SC.Wrapper style={{ position: "relative", display: "inline-block" }}>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleImageChange(e, "logoImage")}
              style={{ display: "none" }}
              ref={fileInputRefLogo}
            />
            <Button
              caption="Choose file"
              onClick={() => fileInputRefLogo.current.click()}
              fontSize="12px"
              style={{
                background: "#f3f3f3",
                color: theme.colors.white,
                minWidth: "100px",
                height: "25px",
                borderRadius: "3px",
                border: "1px solid #949494",
                position: "relative",
                zIndex: "1",
              }}
            />
            <span style={{ fontSize: "11px", marginLeft: "5px" }}>
              Please select a file with size up to 5MB.
            </span>
          </SC.Wrapper>
        </Label>
        <div
          style={{
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            width: "83%",
          }}
        >
          {data?.logoImage && (
            <div style={{ display: "flex", marginTop: "5px" }}>
              <img
                src={data?.logoImage}
                alt={""}
                style={{
                  maxWidth: "50px",
                  maxHeight: "50px",
                  objectFit: "contain",
                }}
              />
              <SC.CloseIconn onClick={() => handleRemoveImage("logoImage")} />
            </div>
          )}
        </div>
        {/* Display Image Upload */}
        <Label label="Display Image">
          <SC.Wrapper style={{ position: "relative", display: "inline-block" }}>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleImageChange(e, "displayImage")}
              style={{ display: "none" }}
              ref={fileInputRefDisplay}
            />
            <Button
              caption="Choose file"
              onClick={() => fileInputRefDisplay.current.click()}
              fontSize="12px"
              style={{
                background: "#f3f3f3",
                color: theme.colors.white,
                minWidth: "100px",
                height: "25px",
                borderRadius: "3px",
                border: "1px solid #949494",
                position: "relative",
                zIndex: "1",
              }}
            />
            <span style={{ fontSize: "11px", marginLeft: "5px" }}>
              Please select a file with size up to 5MB.
            </span>
          </SC.Wrapper>
        </Label>
        <div
          style={{
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            width: "83%",
          }}
        >
          {data.displayImage && (
            <div style={{ display: "flex", marginTop: "5px" }}>
              <img
                src={data.displayImage}
                alt={""}
                style={{
                  maxWidth: "80px",
                  maxHeight: "30px",
                  objectFit: "contain",
                }}
              />
              <SC.CloseIconn
                onClick={() => handleRemoveImage("displayImage")}
              />
            </div>
          )}
        </div>

        <SC.LabelContainer>
          <SC.Label>
            Property Address <SC.Astrik>*</SC.Astrik>
          </SC.Label>
          <SC.Children>
            <SC.Wrapper>
              <InputField
                name="address"
                value={data.address}
                onChange={handleChange}
                required
              />
            </SC.Wrapper>
          </SC.Children>
        </SC.LabelContainer>
        <SC.LabelContainer>
          <SC.Label>
            Property Reference Number <SC.Astrik>*</SC.Astrik>
          </SC.Label>
          <SC.Children>
            <SC.Wrapper>
              <InputField
                name="referenceNo"
                value={data.referenceNo}
                onChange={handleChange}
                required
                maxLength={15}
                regexType={regexTypes.noSpace}
                uppercase
              />
            </SC.Wrapper>
          </SC.Children>
        </SC.LabelContainer>
        <SC.LabelContainer>
          <SC.Label>Property Contact</SC.Label>
          <SC.Children>
            <SC.Wrapper>
              <InputField
                name="propertyContact"
                value={data.propertyContact}
                onChange={handleChange}
                // capitalize
                regexType={regexTypes.textOnly}
              />
            </SC.Wrapper>
          </SC.Children>
        </SC.LabelContainer>
        {/* Cell Input */}
        <SC.LabelContainer>
          <SC.Label>Contact No.</SC.Label>
          <SC.Children>
            <SC.Wrapper style={{ gap: "10px" }}>
              <CountryCodeDropdown
                name="cellCode"
                defaultValue={data.cellCode}
                onChange={handleChange}
              />

              <InputField
                name="contactNo"
                value={data.contactNo}
                onChange={handleChange}
                type="text"
                style={{ width: "55.5%", height: "29px" }}
                regexType={regexTypes.number}
              />
            </SC.Wrapper>
          </SC.Children>
        </SC.LabelContainer>
        <SC.LabelContainer>
          <SC.Label>Email</SC.Label>
          <SC.Children>
            <InputField
              name="email"
              value={data.email || ""}
              onChange={handleChange}
              type="email"
            />
            {errorKeys.email && (
              <SC.ValidtionMessages>
                {validtionMessages.email}
              </SC.ValidtionMessages>
            )}
          </SC.Children>
        </SC.LabelContainer>
        <SC.LabelContainer>
          <SC.Label>
            Opening Date <SC.Astrik>*</SC.Astrik>
          </SC.Label>
          <SC.Children>
            <SC.Wrapper>
              <DatePicker
                name="openingDate"
                value={
                  data.openingDate
                    ? dayjs(data.openingDate, "YYYY-MM-DD")
                    : null
                }
                format="YYYY-MM-DD"
                onChange={(value) => {
                  // Ensure we only pass the date part
                  const formattedDate = value
                    ? dayjs(value).format("YYYY-MM-DD")
                    : "";
                  handleChange("openingDate", formattedDate);
                }}
                mode="date"
                showTime={false}
                allowClear={false}
                style={{ width: "45%", height: "29px" }}
                // disabledDate={(current) =>
                //   current && current < dayjs().startOf("day")
                // }
                disabledDate={(current) => {
                  const inception = data?.createdOn
                    ? dayjs(data.createdOn, "YYYY-MM-DD")
                    : null;
                  return (
                    inception && current && current.isBefore(inception, "day")
                  );
                }}
                disabled={data?.dateCheckbox == 1}
              />

              <label
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  cursor: "pointer",
                  userSelect: "none",
                }}
              >
                <Checkbox
                  checked={data?.dateCheckbox == 1}
                  onChange={(e) =>
                    handleChange("dateCheckbox", e.target.checked ? 1 : 0)
                  }
                  sx={{
                    "&.Mui-checked": {
                      color: theme.colors.themeColor,
                    },
                  }}
                  size="small"
                />
                <span style={{ fontSize: "11px" }}>
                  Opening Date not required
                </span>
              </label>
            </SC.Wrapper>
          </SC.Children>
        </SC.LabelContainer>
        {isEditing && (
          <SC.LabelContainer>
            <SC.Label>
              Project Inception Date <SC.Astrik>*</SC.Astrik>
            </SC.Label>
            <SC.Children>
              <SC.Wrapper>
                <DatePicker
                  name="createdOn"
                  value={
                    data.createdOn ? dayjs(data.createdOn, "YYYY-MM-DD") : null
                  }
                  format="YYYY-MM-DD"
                  onChange={(value) => {
                    // Ensure we only pass the date part
                    const formattedDate = value
                      ? dayjs(value).format("YYYY-MM-DD")
                      : "";
                    handleChange("createdOn", formattedDate);
                  }}
                  mode="date"
                  showTime={false}
                  allowClear={false}
                  style={{ width: "45%", height: "29px" }}
                  disabledDate={(current) => {
                    const opening = data.openingDate
                      ? dayjs(data.openingDate, "YYYY-MM-DD")
                      : null;
                    return (
                      (current && current > dayjs().endOf("day")) ||
                      (opening && current && current >= opening.startOf("day"))
                    );
                  }}
                />
              </SC.Wrapper>
            </SC.Children>
          </SC.LabelContainer>
        )}
        <SC.LabelContainer>
          <SC.Label>
            Country Name <SC.Astrik>*</SC.Astrik>
          </SC.Label>
          <SC.Children>
            <SC.Wrapper>
              <TimeZoneWithCountryDropdown
                placeholder="Select Country"
                options={countryOptions}
                value={data?.countryName}
                onChange={handleCountryChange}
              />
            </SC.Wrapper>
          </SC.Children>
        </SC.LabelContainer>
        <SC.LabelContainer>
          <SC.Label>
            Time Zone <SC.Astrik>*</SC.Astrik>
          </SC.Label>
          <SC.Children>
            <SC.Wrapper>
              <TimeZoneWithCountryDropdown
                placeholder="Select Timezone"
                options={timezoneOptions}
                value={data?.timeZone}
                onChange={handleTimezoneChange}
                disabled={!data.countryName}
              />
            </SC.Wrapper>
          </SC.Children>
        </SC.LabelContainer>
        <SC.LabelContainer>
          <SC.Label>Property Unit</SC.Label>
          <SC.Children>
            <SC.Wrapper style={{ gap: "10px" }}>
              <PropertyUnitDropdown
                name="unit"
                defaultValue={data.unit}
                onChange={handleChange}
                disabledDropdown={isEditing}
              />
            </SC.Wrapper>
          </SC.Children>
        </SC.LabelContainer>
        {/* <TimeZoneDropdown /> */}
        {/* Buttons */}
        <SC.ButtonContainer>
          <Button
            caption="Cancel"
            onClick={onClose}
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: theme.colors.cancelButton,
              color: theme.colors.white,
              minWidth: "100px",
              borderRadius: "3px",
              height: "30px",
              fontSize: "12px",
            }}
          />
          <Button
            caption={isEditing ? "Save" : "Add"}
            type="submit"
            isLoading={loading}
            color="white"
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: theme.gradient.themeGradient,
              color: theme.colors.white,
              minWidth: "100px",
              height: "30px",
              borderRadius: "3px",
            }}
          />
        </SC.ButtonContainer>
      </SC.FormWrapper>
    </SC.Form>
  );

  return (
    <>
      <SC.DrawerTitlesContainer>
        <SC.DrawerTitles>
          {isEditing ? "Edit Project" : "New Project"}
        </SC.DrawerTitles>
        <SC.CloseIcon>
          <InnoIcons.CloseIcon onClick={onClose} />
        </SC.CloseIcon>
      </SC.DrawerTitlesContainer>
      {(loading || wizardLoading) && <Loader />}
      {isEditing ? (
        <ConfigProvider
          theme={{ token: { colorPrimary: theme.colors.themeColor } }}
        >
          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            style={{ padding: "0 15px" }}
            items={[
              {
                key: "details",
                label: "Project Details",
                children: formContent,
              },
              ...(isAdminOrSuper
                ? [
                    {
                      key: "templates",
                      label: "Folder Templates",
                      children: wizardContent,
                    },
                  ]
                : []),
            ]}
          />
        </ConfigProvider>
      ) : (
        formContent
      )}
    </>
  );
}

export default AddEditProjects;
